export const statsData = [
    { label: 'Clients Served', value: '200+' },
    { label: 'Team Members', value: '45+' },
    { label: 'Years of Experience', value: '15+' }
];
